<template>
  <div class="home_wrap">
    <van-swipe
      :autoplay="2500"
      class="swiper-container"
      @change="onChange"
    >
      <van-swipe-item
        v-for="(image, index) in banner"
        :key="index"
      >
        <router-link :to="image.url">
          <img :src="image.path">
        </router-link>
      </van-swipe-item>
      <div
        ref="dian"
        slot="indicator"
        class="custom-indicator"
      >
        <div
          v-for="(img, x) in banner"
          :key="x"
          :class="x===0?'selected':''"
        />
      </div>
    </van-swipe>

    <div
      v-show="loading && cats.length > 0"
      class="shop_box"
    >
      <div
        v-for="i in cats"
        :key="i.id"
        class="item"
        @click="typeGo(i.id,i.name)"
      >
        <div class="item_img">
          <img
            :src="i.img1"
            alt=""
          >
        </div>
        <p class="item_title">
          {{ i.name }}
        </p>
      </div>
    </div>
    <div
      v-show="!loading"
      class="shop_box query"
    >
      <div
        v-for="i in 10"
        :key="i"
        class="item"
      >
        <div class="item_img" />
        <p class="item_title" />
      </div>
    </div>
    <div
      v-show="loading && merchants.length > 0"
      class="merchant_section"
    >
      <div class="merchant_tit">
        <h5>品牌好店</h5>
      </div>
      <div class="merchant_scroll">
        <div
          v-for="m in merchants"
          :key="m.id"
          class="merchant_card"
          @click="merchantGo(m)"
        >
          <img :src="m.logo" alt="" class="merchant_logo" />
          <p class="merchant_name">{{ m.name }}</p>
          <p class="merchant_count">{{ m.item_count }}件商品</p>
        </div>
      </div>
    </div>
    <div
      v-show="!loading && merchants.length > 0"
      class="merchant_section query"
    >
      <div class="merchant_scroll">
        <div
          v-for="i in 3"
          :key="i"
          class="merchant_card"
        >
          <div class="merchant_logo" />
          <p class="merchant_name" />
          <p class="merchant_count" />
        </div>
      </div>
    </div>
    <div
      v-if="activityData.show_activity > 0"
      class="sale_box"
    >
      <div
        v-show="!loading"
        class="query_box"
      >
        <div class="q q0" />
        <div class="q q1" />
        <div class="q q2" />
        <div class="q q3" />
        <div class="q q4" />
      </div>
      <div class="sale_bg">
        <img
          :src="activityData.image"
          alt=""
        >
      </div>
      <router-link
        :to="activityData.link"
        class="s0"
      />
      <router-link
        :to="activityData.fuli1"
        class="s1"
      />
      <router-link
        :to="activityData.fuli2"
        class="s2"
      />
      <router-link
        :to="activityData.fuli3"
        class="s3"
      />
      <router-link
        :to="activityData.fuli4"
        class="s4"
      />
    </div>
    <div
      v-if="seckillData.show_seckill"
      class="seckill_box"
    >
      <div class="kill_tit">
        <div class="kill_wrap">
          <div class="tit">
            商品秒杀
          </div>
          <!-- <div class="active_time">12点场</div> -->
        </div>
        <div
          v-show="showCount"
          class="kill_wrap"
        >
          <p
            v-if="stimeCountTime>0"
            class="count_tip"
          >
            <span class="advance" />距离本场开始
          </p>
          <p
            v-else
            class="count_tip"
          >
            <span class="advance" />距离本场结束
          </p>
          <div class="count_time">
            <div class="count con1">
              {{ timer.hr }}
            </div>
            <span>:</span>
            <div class="count con2">
              {{ timer.min }}
            </div>
            <span>:</span>
            <div class="count con3">
              {{ timer.sec }}
            </div>
          </div>
        </div>
      </div>
      <div class="kill_list">
        <div
          v-for="item in seckillData.data.item"
          :key="item.id"
          class="kill_item"
          @click="$router.push('/seckill')"
        >
          <img
            :src="item.thumb"
            alt=""
          >
          <p class="van-multi-ellipsis--l2">
            {{ item.title }}
          </p>
          <div
            class="kill_price numberFont"
            v-html="'<span>¥</span>'+$parent.bigNumeber(item.price)"
          />
          <div class="old_price">
            ¥{{ item.original_price }}
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="hotData.show_high_sales_items && hotData.list.length"
      class="hot_box"
    >
      <div class="home_tit">
        <div class="line l1" />
        <h5>精选热卖</h5>
        <div class="line l2" />
      </div>
      <div class="hot_list">
        <div
          v-for="item in hotData.list"
          :key="item.id"
          class="item"
          @click="$router.push('/details/'+item.id)"
        >
          <img
            :src="item.img"
            alt=""
          >
          <p class="hot_tit van-multi-ellipsis--l2">
            {{ item.title }}
          </p>
          <p
            class="hot_prize numberFont"
            v-html="'<span>¥</span>'+$parent.bigNumeber(item.price)"
          />
        </div>
      </div>
    </div>
    <div
      v-if="recommendData.show_recommend && recommendData.list.length"
      class="hot_box"
    >
      <div class="home_tit">
        <div class="line l1" />
        <h5>为你推荐</h5>
        <div class="line l2" />
      </div>
      <div class="hot_list">
        <div
          v-for="item in recommendData.list"
          :key="item.id"
          class="item"
          @click="$router.push('/details/'+item.id)"
        >
          <img
            :src="item.img"
            alt=""
          >
          <p class="hot_tit van-multi-ellipsis--l2">
            {{ item.title }}
          </p>
          <p
            class="hot_prize numberFont"
            v-html="'<span>¥</span>'+$parent.bigNumeber(item.price)"
          />
        </div>
      </div>
    </div>
    <div
      v-if="newLotteryData.show_new_lottery && newLotteryData.data.list.length"
      class="hot_box"
    >
      <div class="home_tit">
        <div class="line l1" />
        <h5>新人专享</h5>
        <div class="line l2" />
        <span
          class="more_btn"
          @click="$router.push('/newshop')"
        >进入专区</span>
      </div>
      <div class="hot_list">
        <div
          v-for="item in newLotteryData.data.list"
          :key="item.id"
          class="item"
          @click="$router.push('/details/'+item.id)"
        >
          <img
            :src="item.img"
            alt=""
          >
          <p class="hot_tit van-multi-ellipsis--l2">
            {{ item.title }}
          </p>
          <p
            class="hot_prize numberFont"
            v-html="'<span>¥</span>'+$parent.bigNumeber(item.price)"
          />
        </div>
      </div>
    </div>
    <div
      v-show="show_img"
      class="mask"
      @click="hideDown"
    >
      <div class="wrapper">
        <div
          class="close_ad"
          @click="hideDown"
        />
        <div
          class="icon"
          @click.stop="goToAdvert"
        >
          查看详情
        </div>
        <div
          class="block"
          @click.stop
        >
          <img
            :src="home_advert.activity_img"
            @click.stop="goToAdvert"
          >
        </div>
      </div>
    </div>
    <!-- 在线客服入口暂时隐藏
    <div
      v-if="msg_show"
      class="kefu"
      :class="show_kefu?'':'kefu_hide'"
      @click="kefu_to"
    >
      <img
        class="kefu_img"
        src="../images/index/kefu.png"
      >
    </div>
    -->
  </div>
</template>

<script>

    import Vue from 'vue';
    import Fetch from '../../utils/fetch'
    import {Swipe, SwipeItem, NoticeBar, Overlay, Icon} from "vant";

    Vue.use(NoticeBar).use(Overlay).use(Icon);

    export default {
        name: "Index",
        components: {
            VanSwipe: Swipe,
            VanSwipeItem: SwipeItem,
        },
        data() {
            return {
                show_kefu:false,
                msg_show: true,
                banner: [],
                loading: false,
                showCount: true,
                icon: [],
                data: {},
                cats: [],
                islogin: false,
                show_img: false,
                home_advert: {},
                activityData: {},
                hotData:{},
                recommendData:{},
                newLotteryData:{},
                timer: {
                    hr:'',
                    min: '',
                    sec:''
                },
                countTime:'',
                stimeCountTime: '',
                seckillData:{},
                merchants: []
            };
        },
        created() {
            this.$parent.footer('index');
        },
        mounted() {
            this.start();
            var that = this;
            document.body.addEventListener("scroll",function(){
                if(!that.show_kefu){
                    return;
                }
                that.show_kefu = false;
            },false);
            document.addEventListener('click',function(ev){
                if(ev.target.className != 'kefu_img'){
                    that.show_kefu = false;
                }
            },false);
        },
        methods: {
            kefu_to(){
            if(this.show_kefu){
                this.$router.push('/kefu');
            }
            this.show_kefu = !this.show_kefu;

            },
            hideDown() {
                this.show_img = false;
                this.$store.commit('setShowAdvert', false);
            },
            countdown: function () {
                if(this.seckillData.show_seckill){
                    
                    var msec;
                    if(this.stimeCountTime){
                        msec = this.stimeCountTime
                    }else{
                        msec = this.countTime;
                    }
                    if (msec >= 0 && msec <=360000) {
                        let hr = parseInt(msec / 60 / 60)
                        let min = parseInt(msec / 60 % 60)
                        let sec = parseInt(msec % 60)
                        this.timer.hr = hr > 9 ? hr : '0' + hr
                        this.timer.min = min > 9 ? min : '0' + min
                        this.timer.sec = sec > 9 ? sec : '0' + sec
                        
                        if(this.stimeCountTime){
                            this.stimeCountTime-=1;
                        }else{
                            this.countTime-=1;
                        }
                        const that = this
                        setTimeout(function () {
                            that.countdown()
                        }, 1000)
                    }else if(msec >360000){
                        this.showCount = false;
                    }else{
                        return;
                    }
                    
                }
            },
            start() {
                var show_advert = this.$store.state.home.show_advert;
                Fetch('/index/int').then((r) => {
                    this.data = r.data;
                    
                    // 轮播
                    this.banner = r.data.banner || [];
                    
                    // 商品分类
                    this.cats = r.data.cats || [];
                    
                    // 活动入口
                    this.activityData = r.data.activity || {};
                    
                    // 精选热卖
                    this.hotData = r.data.high_sales_items || { list: [] };
                    
                    // 系统推荐
                    this.recommendData = r.data.recommend || { list: [] };
                    
                    // 新人专享
                    this.newLotteryData = r.data.new_lottery || { data: { list: [] } };
                    
                    // 秒杀
                    this.seckillData = r.data.seckill || { data: { rest_second: 0, stime_second: 0 } };
                    this.countTime = this.seckillData.data.rest_second || 0;
                    this.stimeCountTime = this.seckillData.data.stime_second || 0;
                    this.countdown();
                }).catch(() => {
                    this.banner = [];
                    this.cats = [];
                }).finally(() => {
                    this.loading = true;
                });
                Fetch("/shop/merchants").then((r) => {
                    this.merchants = r.data.list || [];
                }).catch(() => {
                    this.merchants = [];
                });
                Fetch("/index/webconfig").then((r) => {
                    this.home_advert = r.data.ad || {};
                    if (r.data.ad && r.data.ad.activity_status && r.data.ad.activity_img) {
                        this.show_img = true;
                    }

                }).catch(() => {
                    this.home_advert = {};
                });

            },
            typeGo(id,one){
                this.$router.push({
                    path: 'type',
                    query: {
                        id: id,
                        type1:one,
                    },
                })
            },
            merchantGo(m){
                this.$router.push({
                    path: 'type',
                    query: {
                        merchant_id: m.id,
                        type1: m.name,
                    },
                })
            },
            onChange(index) {
                let els = this.$refs.dian.querySelectorAll("div");
                for (let i = 0; i < els.length; i++) {
                    els[i].className = "";
                }
                els[index].className = "selected";
            },
            // to(id) {
            //     this.$router.push('/details/' + id);
            // },
            // iconTo(url) {
            //     this.$router.replace(url);
            // },
            goToAdvert() {
				if (this.home_advert.url) {
				    if (this.home_advert.url.indexOf("http") > -1) {
				      window.location.href = this.home_advert.url;
				    } else {
				      this.$router.push({ path: "/" + this.home_advert.url });
				    }
				}
            }
        }
    };
</script>

<style lang="less" scoped>
    .home_wrap{
        width: 100%;
        min-height: 100vh;
        max-width: 500px;
        margin: 0 auto;
        padding-bottom: 18px;
        box-sizing: border-box;
        background: linear-gradient(180deg, #fff3f4 0, #f6f6f6 128px, #f6f6f6 100%);
    }
    .custom-indicator {
        position: absolute;
        height: 4px;
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        bottom: 11px;
        left: 0;
        div{
            width:10px;
            height:4px;
            background:rgba(255,255,255,1);
            border-radius:2px;
            opacity:0.5;
            margin: 0 2px;
            float: left;
            transition: all 0.3s;
        }
        div.selected{
            width:17px;
            height:4px;
            background:rgba(255,255,255,1);
            border-radius:2px;
            opacity: 1;
        }
    }
    .swiper-container{
        width: calc(100% - 24px);
        height: 164px;
        margin: 12px auto 0;
        border-radius: 16px;
        overflow: hidden;
        box-shadow: 0 10px 24px rgba(227, 56, 46, 0.12);
        .van-swipe-item{
            overflow: hidden;
        }
        a{
            display: block;
            width: 100%;
            height: 100%;
        }
        img{
            display: block;
            height: 100%;
            width: 100%;
            object-fit: cover;
        }
    }
    .shop_box{
        width: calc(100% - 24px);
        margin: 12px auto 0 auto;
        background:rgba(255,255,255,1);
        border-radius:18px;
        padding: 16px 8px 6px 8px;
        display: flex;
        flex-wrap: wrap;
        justify-content: flex-start;
        box-shadow: 0 8px 22px rgba(15, 23, 42, 0.06);
        .item{
            width: 20%;
            margin: 0 0 12px 0;
            display: flex;
            flex-direction: column;
            align-items: center;
            transition: transform 0.2s ease;

            &:active {
                transform: scale(0.96);
            }

            .item_img{
                width: 46px;
                height: 46px;
                border-radius: 14px;
                overflow: hidden;
                background: linear-gradient(180deg, rgba(255, 241, 241, 0.95) 0%, rgba(255, 248, 248, 0.98) 100%);
                box-shadow: 0 8px 18px rgba(227, 56, 46, 0.08);
                img{
                    display: block;
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                }
            }
            .item_title{
                width: 100%;
                margin-left: 0;
                line-height: 15px;
                font-size: 11px;
                color: #333333;
                margin-top: 6px;
                text-align: center;
                padding: 0 2px;
            }
        }
    }
    .shop_box.query{
        .item{
            .item_img{
                border-radius: 16px;
                background: #f0f0f0;
            }
            .item_title{
                width: 100%;
                height: 14px;
                margin-left: 0;
                background: #f0f0f0;
                border-radius: 7px;
            }
        }
        
    }
    .sale_box{
        width: 375px;
        height: 343px;
        margin-top: 9px;
        position: relative;
        .sale_bg{
            position: absolute;
            top: 0;
            right: 0;
            z-index: 1;
            img{
                width: 100%;
                height: 100%;
            }
        }
        .s0,.q0{
            width: 348px;
            height: 88px;
            position: absolute;
            top: 91px;
            left: 14px;
            z-index: 3;
            img{
                width: 100%;
                height: 100%;
            }
        }
        .s1,.s2,.s3,.s4,.q1,.q2,.q3,.q4{
            width: 171px;
            height: 72px;
            position: absolute;
            z-index: 3;
            img{
                width: 100%;
                height: 100%;
            }
        }
        .q{
            background: #f0f0f0;
        }
        .s1,.q1{
            top: 182px;
            left: 14px;
        }
        .s2,.q2{
            top: 182px;
            left: 189px;
        }
        .s3,.q3{
            top: 258px;
            left: 14px;
        }
        .s4,.q4{
            top: 258px;
            left: 189px;
        }
        
        .query_box{
            position: absolute;
            z-index: 5;
            width: 100%;
            height: 100%;
            top: 0;
            left: 0;
            background: #f6f6f6;
        }
    }
    
    
    .seckill_box{
        width:calc(100% - 24px);
        padding: 14px 13px 4px 13px;
        background:linear-gradient(180deg, #fffafa 0%, #ffffff 56%);
        border-radius:18px;
        margin: 12px auto 0 auto;
        box-shadow: 0 10px 24px rgba(227, 56, 46, 0.08);
        .kill_tit{
            display: flex;
            justify-content: space-between;
            align-items: center;
            .kill_wrap{
                display: flex;
                justify-content: flex-start;
                align-items: center;
            }
            .tit{
                font-size: 16px;
                font-weight:600;
                color:rgba(0,0,0,.8);
                line-height:22px;
            }
            .active_time{
                height: 21px;
                line-height: 21px;
                padding: 0 5px;
                color: #FF1300;
                font-size: 12px;
                font-weight: 400;
                border-radius:11px;
                border:1px solid rgba(241,34,17,1);
                background-color: #FEEEEC;
                margin-left: 5px;
            }
            .count_tip{
                height:18px;
                font-size:12px;
                color:rgba(86,85,91,1);
                line-height:18px;
                display: flex;
                align-items: center;
                justify-content: flex-start;
            }
            .count_time{
                display: flex;
                justify-content: space-between;
                font-size: 12px;
                text-align: center;
                margin-left: 8px;
                .count{
                    width:20px;
                    height:18px;
                    line-height:18px;
                    background:rgba(65,64,70,1);
                    border-radius:3px;
                    color: #FFFFFF;
                }
                span{
                    width: 6px;
                    height: 18px;
                    line-height: 18px;
                    color: #414046;
                }
            }
        }
        .kill_list{
            width: 100%;
            display: flex;
            flex-wrap: wrap;
            justify-content: space-between;
            margin-top: 10px;
            .kill_item{
                width: calc((100% - 16px) / 3);
                display: flex;
                flex-direction: column;
                margin-bottom: 10px;
                padding: 8px;
                border-radius: 14px;
                background: #fff5f5;
                transition: transform 0.2s ease, box-shadow 0.2s ease;

                &:active {
                    transform: scale(0.98);
                    box-shadow: 0 6px 14px rgba(227, 56, 46, 0.1);
                }

                img{
                    width: 100%;
                    height: 96px;
                    border-radius: 10px;
                    object-fit: cover;
                }
                p{
                    line-height: 20px;
                    height: 40px;
                    color: #414046;
                    font-size:12px;
                    margin-top: 6px;
                }
                .kill_price{
                    display: flex;
                    justify-content: flex-start;
                    align-items: baseline;
                    height: 21px;
                    line-height: 21px;
                    margin-top: 0px;
                    white-space: nowrap;
                    font-size: 15px;
                    font-weight: bold;
                    color:#f12211;
                }
                .old_price{
                    font-size: 12px;
                    line-height: 17px;
                    margin-top: -2px;
                    color:#B3B3B3;
                    text-decoration: line-through;
                }
            }
        }
    }
    
    .scroll_wrap::-webkit-scrollbar {
        display: none;
    }
    .hot_box{
        margin-top: 12px;
        padding: 0 12px;
        .home_tit{
            position: relative;
            .more_btn{
                position: absolute;
                right: 0;
                top: 0;
                height: 24px;
                line-height: 24px;
                font-size: 12px;
                font-weight: 400;
                color: #999;
            }
        }
        .hot_list{
            width: 100%;
            background:linear-gradient(180deg,rgba(255,255,255,1) 0%,rgba(252,252,252,1) 100%);
            border-radius:18px;
            padding: 14px 12px;
            display: flex;
            flex-wrap: wrap;
            justify-content: space-between;
            margin-top: 12px;
            box-shadow: 0 10px 24px rgba(15, 23, 42, 0.05);
            .item{
                width: calc((100% - 10px) / 2);
                padding-bottom: 12px;
                background-color: #FFFFFF;
                border-radius: 14px;
                margin-bottom: 10px;
                overflow: hidden;
                transition: transform 0.2s ease, box-shadow 0.2s ease;

                &:active {
                    transform: scale(0.98);
                    box-shadow: 0 8px 18px rgba(15, 23, 42, 0.08);
                }

                img{
                    display: block;
                    width: 100%;
                    height: 170px;
                    object-fit: cover;
                }
                .hot_tit{
                    width: calc(100% - 20px);
                    margin: 10px auto 0 auto;
                    color:#455A64;
                    font-size:12px;
                    line-height: 17px;
                }
                .hot_prize{
                    width: calc(100% - 20px);
                    margin: 7px auto 0 auto;
                    height:18px;
                    font-size:13px;
                    font-weight:600;
                    color:rgba(240,48,65,1);
                    line-height:18px;
                }
            }
        }
    }
    .advance{
        width: 35px;
        height: 16px;
        background: url(../images/index/ad.png) no-repeat center center;
        background-size: 100% 100%;
        margin-right: 4px;
    }
    .merchant_section{
        width: calc(100% - 24px);
        margin: 12px auto 0 auto;
        background: linear-gradient(180deg, #ffffff 0%, #fff9f7 100%);
        border-radius: 18px;
        padding: 14px 0 14px 14px;
        box-shadow: 0 10px 24px rgba(15, 23, 42, 0.05);
        .merchant_tit{
            margin-bottom: 10px;
            h5{
                font-size: 16px;
                font-weight: 600;
                color: rgba(0,0,0,.8);
                line-height: 22px;
            }
        }
        .merchant_scroll{
            display: flex;
            overflow-x: auto;
            -webkit-overflow-scrolling: touch;
            &::-webkit-scrollbar{
                display: none;
            }
            .merchant_card{
                flex-shrink: 0;
                width: 88px;
                display: flex;
                flex-direction: column;
                align-items: center;
                margin-right: 12px;
                padding: 10px 8px;
                border-radius: 14px;
                background: rgba(255, 255, 255, 0.92);
                box-shadow: inset 0 0 0 1px rgba(227, 56, 46, 0.05);
                transition: transform 0.2s ease;

                &:active {
                    transform: scale(0.97);
                }

                .merchant_logo{
                    width: 56px;
                    height: 56px;
                    border-radius: 50%;
                    object-fit: cover;
                    background: #f5f5f5;
                }
                .merchant_name{
                    width: 100%;
                    font-size: 12px;
                    color: #333;
                    line-height: 17px;
                    margin-top: 8px;
                    text-align: center;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                }
                .merchant_count{
                    font-size: 10px;
                    color: #999;
                    line-height: 14px;
                    margin-top: 2px;
                    transform: scale(0.85);
                }
            }
        }
    }
    .merchant_section.query{
        .merchant_scroll{
            .merchant_card{
                .merchant_logo{
                    background: #f0f0f0;
                }
                .merchant_name{
                    width: 64px;
                    height: 14px;
                    background: #f0f0f0;
                    border-radius: 3px;
                    color: transparent;
                }
                .merchant_count{
                    width: 40px;
                    height: 12px;
                    background: #f0f0f0;
                    border-radius: 3px;
                    color: transparent;
                }
            }
        }
    }
    .mask{
        position: fixed;
        z-index: 100;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(0, 0, 0, 0.6);
        .wrapper{
            width: 262px;
            height: 418px;
            position: absolute;
            top: 50%;
            left: 50%;
            margin-top: -209px;
            margin-left: -131px;
        }
        .close_ad{
            width: 24px;
            height: 24px;
            background: url(../images/index/close.png) no-repeat center center;
            background-size: 100% 100%;
            position: absolute;
            right: 20px;
            top: 22px;
            z-index: 15;
        }
        .block{
            width: 235px;
            height: 340px;
            position: absolute;
            top: 25px;
            left: 14px;
            img{
                width: 100%;
            }
        }
        .icon{
            width: 126px;
            height: 34px;
            background: #f9481a;
            text-align: center;
            line-height: 34px;
            color: #ffffff;
            font-size: 15px;
            border-radius: 17px;
            position: absolute;
            z-index: 3;
            left: 66px;
            bottom: 20px;
            box-shadow: 0px 2px 10px rgba(240,48,65,1);
        }
    }
</style>
